export const assessmentList = "ASSESSMENT_LIST";
export const courseAssessmentList = "COURSE_ASSESSMENT_LIST";
export const assessmentArtifactList = "ASSESSMENT_ARTIFACT_LIST";
export const coursePublishedAssessmentList = "COURSE_PUBLISHED_ASSESSMENT_LIST";
